module.exports = __webpack_public_path__ + "static/img/chain-name.fa6f7f77.png";